import { ChangeDetectorRef, Component, NgZone, OnDestroy } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { developerConsole } from '@services/developer-console/developer-console.store';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-developer-console',
    standalone: true,
    imports: [ CdkTrapFocus ],
    templateUrl: './developer-console.component.html',
    styleUrl: './developer-console.component.scss',
})
export class DeveloperConsoleComponent implements OnDestroy
{
    public readonly console = developerConsole;
    public isOpen = false;
    private readonly changes: Subscription;

    constructor(zone: NgZone, changeDetector: ChangeDetectorRef)
    {
        this.changes = this.console.changes.subscribe(() =>
        {
            if (this.isOpen)
            {
                zone.run(() => changeDetector.markForCheck());
            }
        });
    }

    public ngOnDestroy(): void
    {
        this.changes.unsubscribe();
    }

    public close(): void
    {
        this.isOpen = false;
    }
}
